export default __webpack_public_path__ + "static/media/sortUp.8d51de4d.svg";